import React from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import View from './view';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class Offers extends React.Component {

  state = {
    load: false,
    message: '',
    offer: [],
    viewEdit: [], menuPermission:[]
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('offers-scroll', this.props.menus);
    if (menuPermission.view) {
      this.getOffers();
    }
    this.setState({ menuPermission })
  }

  getOffers() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Offers Details'
    });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId },
      url: Server() + 'offer/get.php',
      success: function(data)
      {

        context.setState({
          load: false,
        });

        try {
          data = JSON.parse(data);
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            offer: data,
            load: false
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    return (
      <div>
        <Title title='Offers Scroll' openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view  ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '1%'}}>
                <View offer={this.state.offer} offerview={this.state.offerview}
                      offeredit={this.state.offeredit} menuPermission={this.state.menuPermission}
                      getOffers={this.getOffers.bind(this)}/>
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Offers;
